import { render, staticRenderFns } from "./BrandsSearch.vue?vue&type=template&id=b4e8ad22&scoped=true"
import script from "./BrandsSearch.vue?vue&type=script&lang=ts"
export * from "./BrandsSearch.vue?vue&type=script&lang=ts"
import style0 from "./BrandsSearch.vue?vue&type=style&index=0&id=b4e8ad22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e8ad22",
  null
  
)

export default component.exports